import { MOBILE_BREAKPOINT_WIDTH } from 'helpers/globals'

export default _ => window.matchMedia(`only screen and (max-width: ${MOBILE_BREAKPOINT_WIDTH}px)`).matches



// WEBPACK FOOTER //
// ./src/helpers/onMobile.js